import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const SignupSocialProof = ({ intl }) => (
  <>
    <div className='ps-row text-center'>
      <div className='col-xs-12' style={{ marginBottom: '32px' }}>
        <h2>
          <FormattedMessage
            id='referrals.signup_social_proof.space_create'
            defaultMessage='Space to create'
          />
        </h2>
        <p>
          <FormattedMessage
            id='referrals.signup_social_proof.book_location'
            defaultMessage='Peerspace is the easiest way to book locations for your next photo shoot, film shoot, meeting, or event.'
          />
        </p>
      </div>

      <div className='col-xs-12 col-md-4 social-proof-img-container main-img'>
        <picture>
          <source
            srcSet='//img.peerspace.com/image/upload/g_auto,q_auto,f_auto,dpr_auto/c_fill,w_400/referral-signup/user-content-1'
            media='(min-width: 768px)'
          />
          <img
            src='//img.peerspace.com/image/upload/g_auto,q_auto,f_auto,dpr_auto/c_fill,w_600,ar_0.90/referral-signup/user-content-1'
            alt={intl.formatMessage({
              id: 'referrals.signup_social_proof.woman_in_orange',
              defaultMessage: 'woman in orange'
            })}
          />
        </picture>
      </div>
      <div className='col-xs-6 col-md-4 social-proof-img-container sub-img-1'>
        <picture>
          <source
            srcSet='//img.peerspace.com/image/upload/g_auto,q_auto,f_auto,dpr_auto/c_fill,w_400/referral-signup/user-content-2'
            media='(min-width: 768px)'
          />
          <img
            src='//img.peerspace.com/image/upload/g_auto,q_auto,f_auto,dpr_auto/c_fill,w_400,h_400/referral-signup/user-content-2'
            alt={intl.formatMessage({
              id: 'referrals.signup_social_proof.woman_in_pink',
              defaultMessage: 'woman in pink'
            })}
          />
        </picture>
      </div>
      <div className='col-xs-6 col-md-4 social-proof-img-container sub-img sub-img-2'>
        <picture>
          <source
            srcSet='//img.peerspace.com/image/upload/g_auto,q_auto,f_auto,dpr_auto/c_fill,w_400/referral-signup/user-content-3'
            media='(min-width: 768px)'
          />
          <img
            src='//img.peerspace.com/image/upload/g_auto,q_auto,f_auto,dpr_auto/c_fill,w_400,h_400/referral-signup/user-content-3'
            alt={intl.formatMessage({
              id: 'referrals.signup_social_proof.man_in_red',
              defaultMessage: 'man in red'
            })}
          />
        </picture>
      </div>

      <div className='col-xs-12 margin-lg-top'>
        <button
          className='btn-link remove-click-styling'
          onClick={() => {
            window.scrollTo(0, 0);
          }}
        >
          <FormattedMessage
            id='referrals.signup_social_proof.claim_discount'
            defaultMessage='Claim your discount'
          />
          &nbsp;
          <i className='icon-back ico-sm margin-sm-right rotate-arrow' />
        </button>
      </div>
    </div>

    <div className='ps-row text-center' style={{ marginTop: '64px' }}>
      <div className='col-xs-12' style={{ marginBottom: '32px' }}>
        <h2>
          <FormattedMessage
            id='referrals.signup_social_proof.all_kinds'
            defaultMessage='Spaces of all kinds'
          />
        </h2>
        <p>
          <FormattedMessage
            id='referrals.signup_social_proof.powerful_search'
            defaultMessage='Use our powerful search and filters to find the right space for your project.'
          />
        </p>
      </div>

      <div className='col-xs-6 col-md-3 spaces-img-wrap'>
        <img
          className='img-responsive'
          src='https://assets.peerspace.com/guest-referral/house.jpg'
          alt={intl.formatMessage({
            id: 'referrals.signup_social_proof.house',
            defaultMessage: 'house'
          })}
        />
        <p className='heavy margin-md-top'>
          <FormattedMessage
            id='referrals.signup_social_proof.houses'
            defaultMessage='Houses'
          />
        </p>
      </div>

      <div className='col-xs-6 col-md-3 spaces-img-wrap'>
        <img
          className='img-responsive'
          src='https://assets.peerspace.com/guest-referral/studio.jpg'
          alt={intl.formatMessage({
            id: 'referrals.signup_social_proof.studio',
            defaultMessage: 'studio'
          })}
        />
        <p className='heavy margin-md-top'>
          <FormattedMessage
            id='referrals.signup_social_proof.studios'
            defaultMessage='Studios'
          />
        </p>
      </div>

      <div className='col-xs-6 col-md-3 spaces-img-wrap'>
        <img
          className='img-responsive'
          src='https://assets.peerspace.com/guest-referral/warehouse.jpg'
          alt={intl.formatMessage({
            id: 'referrals.signup_social_proof.warehouse',
            defaultMessage: 'warehouse'
          })}
        />
        <p className='heavy margin-md-top'>
          <FormattedMessage
            id='referrals.signup_social_proof.warehouses'
            defaultMessage='Warehouses'
          />
        </p>
      </div>

      <div className='col-xs-6 col-md-3 spaces-img-wrap'>
        <img
          className='img-responsive'
          src='https://assets.peerspace.com/guest-referral/pool.jpg'
          alt={intl.formatMessage({
            id: 'referrals.signup_social_proof.pool',
            defaultMessage: 'pool'
          })}
        />
        <p className='heavy margin-md-top'>
          <FormattedMessage
            id='referrals.signup_social_proof.pools'
            defaultMessage='Pools'
          />
        </p>
      </div>

      <div className='col-xs-12 text-center'>
        <button
          className='btn-link remove-click-styling'
          onClick={() => {
            window.scrollTo(0, 0);
          }}
        >
          <FormattedMessage
            id='referrals.signup_social_proof.claim_ur_discount'
            defaultMessage='Claim your discount'
          />
          &nbsp;
          <i className='icon-back ico-sm margin-sm-right rotate-arrow' />
        </button>
      </div>
    </div>

    <div className='ps-row text-center' style={{ marginTop: '64px' }}>
      <div className='col-xs-12' style={{ marginBottom: '32px' }}>
        <h2>
          <FormattedMessage
            id='referrals.signup_social_proof.trusted_by_teams'
            defaultMessage='Trusted by top creative teams'
          />
        </h2>
      </div>

      <div className='col-xs-12 flex social-proof-imgs-wrap'>
        <img
          className='social-proof-img'
          src='https://assets.peerspace.com/disney.png?v=rb'
          alt='disney'
        />
        <img
          className='social-proof-img'
          src='https://assets.peerspace.com/netflix.png?v=rb'
          alt='netflix'
        />
        <img
          className='social-proof-img'
          src='https://assets.peerspace.com/vogue.png?v=rb'
          alt='vogue'
        />
        <img
          className='social-proof-img'
          src='https://assets.peerspace.com/espn.png?v=rb'
          alt='espn'
        />
        <img
          className='social-proof-img'
          src='https://assets.peerspace.com/apple.png?v=rb'
          alt='apple'
        />
        <img
          className='social-proof-img'
          src='https://assets.peerspace.com/vice.png?v=rb'
          alt='vice'
        />
      </div>
    </div>
  </>
);

SignupSocialProof.propTypes = {
  intl: intlShape
};

export default injectIntl(SignupSocialProof);
